<template lang="pug">
  .messaging.container
    .has-background-grey.has-text-light.p-10
    .messages.section.has-background-light(v-if="room.messages" ref="messages")
      .message.is-clearfix(v-for="message in room.messages.items")
        div(
          :class="{'is-pulled-left': message.user_id !== user.id, 'is-pulled-right': message.user_id === user.id}"
        )
          strong(v-if="message.user")
            b-icon(icon="account")
            |  {{message.user.fullName}}
          .inline.p-10.is-rounded.has-background-white
            div {{message.content}}

            .is-size-7.has-text-right.is-italic.has-text-grey-light
              b-icon(icon="clock-outline")
              |  {{ message.created_at | format }}

    .has-background-white.send-message
      b-field
        b-input(type="textarea" v-model="newMessage" placeholder="Вопрос")

      b-field.has-text-right
        ui-button.is-primary(@click="sendMessage" icon="send" :disabled="!newMessage") Отправить
</template>

<script>
import dayjs from 'dayjs';
import api from '@/api';
import { mapGetters } from 'vuex';

export default {
  name: 'messaging',

  props: {
    room: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      newMessage: '',
    };
  },

  computed: {
    ...mapGetters(['user']),
  },

  watch: {
    room() {
      this.$nextTick(() => {
        this.scrollBottom();
      });
    },
  },

  beforeDestroy() {
    window.Echo.leave(`room.${this.room.id}`);
  },

  created() {
    window.Echo.private(`room.${this.room.id}`).listen('NewMessage', ({ message }) => {
      this.room.messages.add(message);
    });
  },

  mounted() {
    this.scrollBottom();
  },

  methods: {
    async sendMessage() {
      if (!this.newMessage) {
        return;
      }

      const response = await api.for(`rooms/${this.room.id}/messages`).request('post', null, {
        headers: {
          'X-Socket-ID': window.Echo.socketId(),
        },
        data: {
          content: this.newMessage,
        },
      });

      this.room.messages.add(response.data);

      this.newMessage = '';
    },

    scrollBottom() {
      this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight;
    },
  },

  filters: {
    ago(date) {
      if (typeof date === 'object') {
        date = date.date;
      }

      return dayjs().to(dayjs.utc(date));
    },

    format({ date }, format = 'D MMMM YYYY - HH:mm:ss') {
      return date
        ? dayjs(date)
            .add(3, 'hour')
            .format(format)
        : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.messaging {
  max-width: 500px;

  .send-message {
    padding: 20px;
  }
}

.messages {
  height: 500px;
  overflow-y: auto;
}
</style>
